import { render } from "./ContentSection.vue?vue&type=template&id=221c48c1&scoped=true&ts=true"
import script from "./ContentSection.vue?vue&type=script&lang=ts"
export * from "./ContentSection.vue?vue&type=script&lang=ts"

import "./ContentSection.vue?vue&type=style&index=0&id=221c48c1&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221c48c1"]])

export default __exports__